import React from 'react'
import './alertas.css'
import Swal from "sweetalert2";


const Alertas = () => {

  const warningAlert = () => {
    Swal.fire({
      title: "Ejemplo de título de alerta",
      text: "Este texto sirve para descripciones cortas",
      icon: "warning",
      iconColor: '#FCC732',
      customClass: {
        confirmButton: 'btn-ok',
        title: 'alert-title',
        popup: 'alert-bg'
      }
    });
  }

  const dialogAlert = () => {
    Swal.fire({
      title: "¿Quieres eliminar a este usuario?",
      text: "Esta acción no se puede revertir",
      icon: "question",
      iconColor: '#ED1B1B',
      customClass: {
        confirmButton: 'btn-confirm',
        cancelButton: 'btn-cnacel',
        title: 'alert-title',
        popup: 'alert-bg'
      },
      showCancelButton: true,
      confirmButtonText: "Si, ¡eliminar!",
      cancelButtonText: "Cancelar"
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "¡Eliminado!",
          text: "El usuario fue eliminado.",
          icon: "success",
          iconColor: "#1B9925",
          customClass: {
            confirmButton: 'btn-ok',
            title: 'alert-title',
            popup: 'alert-bg'
          }
        });
      }
    });
  }

  const inputAlert = () => {
    Swal.fire({
      title: "Ingresa tu usuario de Github",
      input: "text",
      inputAttributes: {
        autocapitalize: "off"
      },
      showCancelButton: true,
      confirmButtonText: "Enviar",
      showLoaderOnConfirm: true,
      customClass: {
        confirmButton: 'btn-confirm',
        cancelButton: 'btn-cnacel',
        title: 'alert-title',
        popup: 'alert-bg'
      },
      preConfirm: async (login) => {
        try {
          const githubUrl = `
            https://api.github.com/users/${login}
          `;
          const response = await fetch(githubUrl);
          if (!response.ok) {
            return Swal.showValidationMessage(`
              ${JSON.stringify(await response.json())}
            `);
          }
          return response.json();
        } catch (error) {
          Swal.showValidationMessage(`
            Request failed: ${error}
          `);
        }
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: `${result.value.login}'s avatar`,
          imageUrl: result.value.avatar_url,
          customClass: {
            confirmButton: 'btn-ok',
            title: 'alert-title',
          }
        });
      }
    });
  }
  
  const errorAlert = () => {
    Swal.fire({
      icon: "error",
      iconColor: '#ED1B1B',
      title: "Ups...",
      text: "¡Algo salió mal",
      footer: '<a href="/error">¿Porqué tengo este problema?</a>',
      customClass: {
        confirmButton: 'btn-ok',
        title: 'alert-title',
        popup: 'alert-bg'
      }
    });
  }

  return (
    <div className='container-fluid d-flex justify-content-center pb-5 border-bottom border-3'>
      <div className='container p-0 mt-3'>
        <div className='container-lg p-0'>
          <div className='py-3'>
            <p className='short-title font-semibold text-premium-blue mt-4'>Alertas</p>
          </div>
          <div className='row mt-3 row-gap-3 text-premium-blue'>
            <div className='col-12 col-md-3 d-flex justify-content-center'>
                <button className='btn-amc-ch btn-pink-secondary' onClick={warningAlert}>Warning</button>
            </div>
            <div className='col-12 col-md-3 d-flex justify-content-center'>
              <button className='btn-amc-ch btn-pink-secondary' onClick={dialogAlert}>Dialog</button>
            </div>
            <div className='col-12 col-md-3 d-flex justify-content-center'>
              <button className='btn-amc-ch btn-pink-secondary' onClick={inputAlert}>Input</button>
            </div>
            <div className='col-12 col-md-3 d-flex justify-content-center'>
              <button className='btn-amc-ch btn-pink-secondary' onClick={errorAlert}>Error</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Alertas